<template>
  <main>
    <Header></Header>

    <template v-if="orderConfirmWrapper.productKey">
      <img style="width: 70px; height: 70px; margin-top: 40px; margin-bottom: 40px;" src="/static/images/pay_success.png">
      <OrderPayInfo></OrderPayInfo>
      <div class="title2">支付成功，请进入 <span class="link" @click="gotoOrderList">我的订单</span> 查看订单信息</div>
    </template>

    <Footer></Footer>
  </main>
</template>

<script>
import OrderPayInfo from '@/components/OrderPayInfo'
import Footer from '@/components/Footer'
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'PayConfirm',
  components: {OrderPayInfo, Footer},

  mounted () {
    if (!this.isLogin || !this.orderConfirmWrapper.productKey) {
      this.$router.replace('/')
      return
    }

    sessionStorage.removeItem('expireTime')
  },

  methods: {
    gotoOrderList () {
      this.$router.replace('/customerCenter/purchasedResPkg')
    },

  },

  computed: {
    ...mapState(['orderConfirmWrapper']),
    ...mapGetters(['isLogin']),
  },
}
</script>

<style scoped>

  /*main {*/
  /*  width: 100%;*/
  /*  height: 100vh;*/
  /*  display: flex;*/
  /*  flex-direction: column;*/
  /*  justify-content: center;*/
  /*  align-items: center;*/
  /*}*/

  main {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    /*justify-content: center;*/
    align-items: center;
    background: #eee;
  }

  main > img {
    width: 100px;
    height: 100px;
    margin-top: 50px;
    margin-bottom: 10px;
  }

  main div {
    line-height: 28px;
    font-size: 16px;
  }

  .title2 {
    margin: 30px 0;
    font-size: 18px;
    color: #666;
  }

  .link {
    cursor: pointer;
    color: cornflowerblue;
  }

  .link:hover {
    color: #FF9900;
  }

</style>



// WEBPACK FOOTER //
// src/pages/PayConfirm/PayConfirm.vue